<template lang="pug">
#relatorio-rastreabilidade-bloco-pesquisa-filtros
    .filtros
        .bloco-pesquisa-filtros__container
            .bloco-pesquisa-filtros__barra-pesquisa
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    :disabled='carregando',
                    type='text',
                    :placeholder='$t("mensagens.relatorioRastreabilidade.listagem.placeholderPesquisa")',
                    autocomplete='off',
                    @keyup.enter='pesquisar',
                    v-mask='["##########"]'
                )
</template>

<script>
export default {
    name: 'PesquisaFiltroRelatorioRastreabilidade',
    props: {
        carregando: {
            type: Boolean,
            Required: true
        }
    },
    data() {
        return {
            pesquisa: ''
        };
    },
    watch: {
        pesquisa: function () {
            if (!this.pesquisa.length) {
                this.$emit('filtro', '');
            }
        }
    },
    methods: {
        pesquisar() {
            this.$emit('filtro', this.pesquisa);
        }
    }
};
</script>

<style lang="scss">
body {
    overflow-y: hidden;
    overflow-x: hidden;
}

#relatorio-rastreabilidade-bloco-pesquisa-filtros {
    .filtros {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        gap: 10px;
    }

    .bloco-pesquisa-filtros__container {
        width: 100%;
        height: 42px;
        border-radius: 5px;
        background: var(--white);
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        position: relative;
    }

    .bloco-pesquisa-filtros__barra-pesquisa {
        height: 100%;
        display: flex;
        justify-content: center;

        i.el-icon-search {
            color: var(--primary);
            font-size: 25px;
            font-weight: bold;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .filtros-avancados__titulo {
        color: var(--primary);
        font-weight: bold;
    }
}
</style>
